"use client";

import FadeDiv from "@/components/common/FadeDiv";
import Image from "next/image";
import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const logos = [
  <Image
    key={"agents"}
    src="/brands/ProfessionalAgents.svg"
    alt="Professional Agents"
    width={120}
    height={120}
    className="h-16 w-40 mx-8"
  />,
  <Image
    key={"nsi"}
    src="/brands/NSI.svg"
    alt="NSI"
    width={120}
    height={120}
    className="h-16 w-28 opacity-90 mx-8"
  />,
  <Image
    key={"stateFarm"}
    src="/brands/StateFarm.svg"
    alt="State Farm"
    width={120}
    height={120}
    className="h-16 w-28 mx-8"
  />,
  <Image
    key={"delToro"}
    src="/brands/DelToro.svg"
    alt="Del Toro"
    width={120}
    height={120}
    className="h-16 w-20 opacity-80 mx-8"
  />,
  <Image
    key={"farmers"}
    src="/brands/Farmers.svg"
    alt="Farmers"
    width={120}
    height={120}
    className="h-16 w-20 opacity-80 mx-8"
  />,
  <Image
    key={"leavitt"}
    src="/brands/Leavitt.svg"
    alt="Leavitt"
    width={120}
    height={120}
    className="h-16 w-28 opacity-80 mx-8"
  />,
  <Image
    key={"vertafore"}
    src="/brands/Vertafore.svg"
    alt="Vertafore"
    width={120}
    height={120}
    className="h-16 w-28 opacity-80 mx-8"
  />,
  <Image
    key="honeyQuote"
    src="/brands/HoneyQuote.svg"
    alt="HoneyQuote"
    width={120}
    height={120}
    className="h-16 w-28 opacity-80 mx-8"
  />,
  <Image
    key="allstate"
    src="/brands/Allstate.webp"
    alt="Allstate"
    width={120}
    height={120}
    className="h-7 w-28 opacity-80 mx-8"
  />,
  <Image
    key="telefonica"
    src="/brands/Telefonica.webp"
    alt="Telefonica"
    width={120}
    height={120}
    className="h-7 w-28 opacity-80 mx-8"
  />,
  <Image
    key="AAA"
    src="/brands/AAA.svg"
    alt="AAA"
    width={120}
    height={120}
    className="h-12 w-20 opacity-80 mx-8"
  />,
  <Image
    key="systemGroup"
    src="/brands/SystemGroup.svg"
    alt="SystemGroup"
    width={120}
    height={120}
    className="h-12 w-20 opacity-80 mx-8"
  />,
  <Image
    key="covinoc"
    src="/brands/Covinoc.svg"
    alt="Covinoc"
    width={120}
    height={120}
    className="h-12 w-20 opacity-80 mx-8"
  />,
];

const TICKER_SPEED = 30;

const PartnerTicker: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FadeDiv className={clsx("w-full", "lg:mt-8")}>
      <div
        className={clsx("w-full", "h-32", "bg-[#F9F3E6]", "overflow-hidden")}
      >
        <div className={clsx("relative")}>
          <h3
            className={clsx(
              "text-center",
              "text-base",
              "md:text-lg",
              "font-bold",
              "pt-4",
              "font-sans",
              "text-gray-600",
              "mb-2"
            )}
          >
            {t("ticker.title")}
          </h3>
          <div className="w-full overflow-hidden">
            <div
              className="partner-ticker-track flex items-center"
              style={{
                animation: `partner-ticker-scroll ${TICKER_SPEED}s linear infinite`,
                width: "max-content",
              }}
            >
              {[...logos, ...logos].map((logo, idx) => (
                <span key={`logo-${idx}`}>{logo}</span>
              ))}
            </div>
          </div>
          <style jsx>{`
            @keyframes partner-ticker-scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }
            .partner-ticker-track {
              min-width: 200%;
            }
          `}</style>
        </div>
      </div>
    </FadeDiv>
  );
};

export default PartnerTicker;
